import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/area");
export var getAllAreas = function getAllAreas(params) {
  return getReq(BASE_URL, {
    params: params
  });
};